import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useLocation } from "react-router";

console.log(`Base v2 - ©${new Date().getFullYear()} Entegral (${import.meta.env.MODE})`);

if (import.meta.env.MODE != "development") {
  // See docs for support of different versions of variation of react router
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
  Sentry.init({
    dsn: "https://5b98217e38f7441591da346c1f9e89bc:b9a49bbffbb845ba983f46560e754a50@sentry.io/180690",
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.5, // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
    tracePropagationTargets: [/^\//, /^https:\/\/base\.entegral\.net/],
    replaysSessionSampleRate: 0.1, // Capture Replay for 10% of all sessions,
    replaysOnErrorSampleRate: 0.5, // plus for 100% of sessions with an error
  });
}
